// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/trading_spread_kind.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/trading_spread_kind.proto.
 */
export const file_bfftypes_v1_trading_spread_kind: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ0eXBlcy92MS90cmFkaW5nX3NwcmVhZF9raW5kLnByb3RvEgtiZmZ0eXBlcy52MSq0AQoRVHJhZGluZ1NwcmVhZEtpbmQSIwofVFJBRElOR19TUFJFQURfS0lORF9VTlNQRUNJRklFRBAAEhwKGFRSQURJTkdfU1BSRUFEX0tJTkRfQVJFQRABEiAKHFRSQURJTkdfU1BSRUFEX0tJTkRfQ0FMRU5EQVIQAhIbChdUUkFESU5HX1NQUkVBRF9LSU5EX1RQUhADEh0KGVRSQURJTkdfU1BSRUFEX0tJTkRfT1RIRVIQBEJCWkBnaXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ0eXBlcy92MTtiZmZ0eXBlc3YxYgZwcm90bzM");

/**
 * TradingSpreadKind classifies which spread variety a bilateral trade
 * belongs to. Used as `repeated TradingSpreadKind` on TradingContract:
 * 空 list = 単独取引、 1+ 要素 = 単軸 / 複合軸スプレッド (例: [AREA, TPR])。
 *
 * Mirrors backend types.v1.TradingSpreadKind 1:1。 None enum 削除 +
 * CRACK → TPR rename + 意味変更 (= O-Take #611-4 / mock-app ec3d04d1 整合)。
 *
 * @generated from enum bfftypes.v1.TradingSpreadKind
 */
export enum TradingSpreadKind {
  /**
   * @generated from enum value: TRADING_SPREAD_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * エリアスプレッド (異エリア)。
   *
   * @generated from enum value: TRADING_SPREAD_KIND_AREA = 1;
   */
  AREA = 1,

  /**
   * カレンダースプレッド (期間)。
   *
   * @generated from enum value: TRADING_SPREAD_KIND_CALENDAR = 2;
   */
  CALENDAR = 2,

  /**
   * TPR スプレッド (時間帯スプレッド、 ピーク × オフピーク等)。 旧 CRACK 改名。
   *
   * @generated from enum value: TRADING_SPREAD_KIND_TPR = 3;
   */
  TPR = 3,

  /**
   * その他のスプレッド。
   *
   * @generated from enum value: TRADING_SPREAD_KIND_OTHER = 4;
   */
  OTHER = 4,
}

/**
 * Describes the enum bfftypes.v1.TradingSpreadKind.
 */
export const TradingSpreadKindSchema: GenEnum<TradingSpreadKind> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_trading_spread_kind, 0);

